import type { RegistryCandidateView } from "./steps/RegistryStep";

// A register's public name and its professional identifier are different for
// STPS, NPPES and Health Pro. REPS has no professional identifier to display.
export const registryPresentation = {
  rpps: {
    sourceName: "RPPS",
    identifierLabel: "RPPS",
  },
  npi: {
    sourceName: "NPPES",
    identifierLabel: "NPI",
  },
  inami: {
    sourceName: "Health Pro",
    identifierLabel: "INAMI",
  },
  big: {
    sourceName: "BIG-register",
    identifierLabel: "BIG",
  },
  om: {
    sourceName: "Ordem dos Médicos",
    identifierLabel: "Ordem dos Médicos",
  },
  stps: {
    sourceName: "STPS",
    identifierLabel: "Autorisations-ID",
  },
  reps: {
    sourceName: "REPS",
    identifierLabel: null,
  },
} as const satisfies Record<
  RegistryCandidateView["registry"],
  { sourceName: string; identifierLabel: string | null }
>;

export function registryFoundLabel(
  registry: RegistryCandidateView["registry"],
  t: (key: string) => string
): string {
  switch (registry) {
    case "rpps":
      return t("Profile found in RPPS");
    case "npi":
      return t("Profile found in NPPES");
    case "inami":
      return t("Profile found in Health Pro");
    case "big":
      return t("Profile found in BIG-register");
    case "om":
      return t("Profile found in Ordem dos Médicos");
    case "stps":
      return t("Profile found in the Danish register");
    case "reps":
      return t("Profile found in REPS");
    default:
      throw new Error(registry satisfies never);
  }
}
